export default __webpack_public_path__ + "static/media/arr.ee4f5604.svg";